export default class homepageLocationSelection {
    constructor() {
        this._init();
    }

    _init () {
        let locationPath = null;
        let $form = $('#locationForm');
        let $images = $('.location-image-js');

        $('.location-select-js').change(e => {
            let value = $(e.currentTarget).val();
            e.preventDefault();

            if (value) {
                $images.addClass('hidden');
                locationPath = $($images[value]).attr('data-pagelink');
                $($images[value]).removeClass('hidden');
            }
        });

        $form.submit(e => {
            e.preventDefault();

            if (!locationPath) {
                window.location.href = $($images[0]).attr('data-pagelink');
                return;
            }

            window.location.href = locationPath;
        });

        $images.click(e => {
            e.preventDefault();
            $form.trigger('submit');
        });
    }
}
